import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/mirr-calculator',
  component: () => import('../../routes/MirrCalculator.svelte'),
  card: {
    id: 'mirr-calculator',
    title: 'MIRR Calculator',
    description: 'Calculate Modified Internal Rate of Return with separate finance and reinvestment rates. Fixes the reinvestment assumption flaw in standard IRR.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/mirr-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'MIRR Calculator – Modified Internal Rate of Return',
    description:
      'Free MIRR calculator to find the Modified Internal Rate of Return. Enter cash flows with separate finance and reinvestment rates for accurate capital budgeting.',
  },
};

export default meta;